import { CollectionFormValidatorError } from './collection-form-validator-error';

export class CollectionFormValidatorResult {
  public Errors: Array<CollectionFormValidatorError>;
  public IsValid: boolean;
  public IsAiValidation: boolean = false;
  public AiButtonId: number;
  public FormId: string;

  public constructor() {
    this.Errors = [];
  }
}

export function isCollectionFormValidatorResult(arg: any): arg is CollectionFormValidatorResult {
  return (arg as CollectionFormValidatorResult) !== undefined;
}


